class SlideInMenu {
    constructor() {
        this.menu = document.querySelector('.js-slide-in-menu');
        if (this.menu) {
            this.bind(this.menu);
        }
    }

    bind() {
        let triggers = document.querySelectorAll('.js-open-menu');
        if (triggers.length) {
            triggers.forEach((trigger) => {
                trigger.addEventListener('click', () => {
                    if (!document.querySelector('body.menu-active')) {
                        SlideInMenu.show();
                        if (document.querySelector('.background-sub')) {
                            document.querySelector('.background-sub').classList.add('active');
                        }
                    } else {
                        SlideInMenu.hide();
                        if (document.querySelector('.background-sub')) {
                            document.querySelector('.background-sub').classList.remove('active');
                        }
                    }
                });
            });
        }

        triggers = document.querySelectorAll('.js-close-menu');
        if (triggers.length) {
            triggers.forEach((trigger) => {
                trigger.addEventListener('click', () => {
                    SlideInMenu.hide();
                    if (document.querySelector('.background-sub')) {
                        document.querySelector('.background-sub').classList.remove('active');
                    }
                });
            });
        }

        window.addEventListener('click', (e) => {
            if (this.menu.contains(e.target) || e.target.closest('.js-open-menu')) {
                // Clicked in box
            } else {
                SlideInMenu.hide();
                if (document.querySelector('.background-sub')) {
                    document.querySelector('.background-sub').classList.remove('active');
                }
            }
        });
    }

    static show() {
        document.body.classList.add('menu-active');
    }

    static hide() {
        document.body.classList.remove('menu-active');
    }
}

export default SlideInMenu;
